import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import RescheduleHistoryModalsWrapper from '../../components/HistoryComps/RescheduleComps/RescheduleHistoryModalsWrapper';
import ShowAllRescheduleHistory from '../../components/HistoryComps/RescheduleComps/ShowAllRescheduleHistory';
import RescheduleHistoryProvider from '../../contexts/RescheduleHistoryProvider';

const Reschedule = () => {
  // rendering appointment reschedule history page component here
  return (
    <>
      <PageTitle title='Reschedule History' />

      <RescheduleHistoryProvider>
        <ShowAllRescheduleHistory />
        <RescheduleHistoryModalsWrapper />
      </RescheduleHistoryProvider>
    </>
  );
};

export default Reschedule;
